import { $api } from "../AxiosInstance";

export class TranslatorService {

  /**
   * @param {Object} params
   * @param {Number} params.page
   * @param {Number} params.size )
   * @param {String} [params.filterCreatedDateStart] - Start date for filtering by creation date (ISO string)
   * @param {String} [params.filterCreatedDateEnd] - End date for filtering by creation date (ISO string)
   * @param {Array<{key: String, value: any}>} [params.sort] - Array of sorting criteria
   * @param {Array<{key: String, value: any}>} [params.search] - Array of search parameters
   * @returns {Promise<Object>}
   */
  static getAllTranslatorsWithParams(params) {
    return $api.post("/api/front/translators", params);
  }


  static getAllTranslators() {
      return  $api.get("/api/front/translators");
  }

  /**
   * @param {Object} newTranslator
   * @param {String} newTranslator.name
   * @param {String} newTranslator.description
   * @param {String} newTranslator.providerType
   * @param {Boolean} newTranslator.isDefault
   * @param {Boolean} newTranslator.isActive
   * @param {Object} newTranslator.authConfig
   */

  static addTranslator(newTranslator) {
    return $api.post("/api/front/translator", newTranslator);
  }

  static getTranslatorById(id) {
    return $api.get(`/api/front/translator/${id}`);
  }

  /**
   * @param {String} id
   * @param {Object} updateTranslator
   * @param {String} updateTranslator.name
   * @param {String} updateTranslator.description
   * @param {String} updateTranslator.providerType
   * @param {Boolean} updateTranslator.isDefault
   * @param {Boolean} updateTranslator.isActive
   * @param {Object} updateTranslator.authConfig
   */

  static updateTranslatorById(updateTranslator ) {
    return  $api.patch(
      `/api/front/translator/${updateTranslator?.id}`,
      updateTranslator,
    );
  }

  static deleteTranslatorById(id) {
    return $api.delete(`/api/front/translator/${id}`);
  }


  /**
   * @param {Object} config
   * @param {String} config.providerType
   * @param {Object} config.authConfig
   */
  static checkTranslatorConfig(config) {
    return  $api.post(
      "/api/front/translator/check-auth-config",
      config,
    );
  }

  static getTranslationProviders() {
      return $api.get("/api/front/translation-provider-types");
  }
}
